import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { propertyManager, standardTenant } from "all_Interfaces";

interface AbstractStatus {
    isSelected : boolean;
    label: string;
    value: string;
}

interface SubjectToSLR {
    isSelected : boolean;
    label: string;
    value: string;
}

export type initialState = {
    leaseId: number;
    leaseType: string;
    propertyName: string;
    propertyId: string;
    investmentId: string;
    investmentName: string;
    propertyManager: propertyManager | null;
    secondaryPropertyManager: propertyManager | null;
    tenantId: string;
    tenantName: string;
    leaspropertyManagerNameType: string;
    leasePopupUpdateComments: string;
    lastmodified: string;
    LastModifiedBy: string;
    createdBy: string;
    created: string;
    leaseCommencement: string | null;
    rentCommencement: string | null;
    expiration: string | null;
    nuveenSigningDate: string | null;
    requestorEmailAddress: string;
    isActive: string;
    unitNumber: string;
    unitSquareFootage: string;
    fileName: string;
    comments: string;
    leaseStatus: string;
    standardTenantName: string;
    naicS_CodeTenant: string;
    xmin: number;
    leaseActivatedDate: string| null;
    tenantContactAvailable: string;
    sustainabilityContactAvailable: string;
    abstractStatus: string | AbstractStatus[];
    subjectToSLR: string | SubjectToSLR[];
    teamMemberId: string;
    
}
const initialState: initialState = {
    leaseId: 0,
    leaseType: "",
    propertyName: "",
    propertyId: "",
    investmentId: "",
    investmentName: "",
    propertyManager: null,
    secondaryPropertyManager: null,
    tenantId: "",
    tenantName: "",
    leaspropertyManagerNameType: "",
    leasePopupUpdateComments: "",
    lastmodified: "",
    LastModifiedBy: "",
    createdBy: "",
    created: "",
    leaseCommencement: "",
    rentCommencement: "",
    expiration: "",
    nuveenSigningDate: "",
    requestorEmailAddress: "",
    isActive: "",
    unitNumber: "",
    unitSquareFootage: "",
    fileName: "",
    comments: "",
    leaseStatus: "",
    standardTenantName: "",
    naicS_CodeTenant: "",
    xmin: 0,
    leaseActivatedDate: "",
    tenantContactAvailable: "",
    sustainabilityContactAvailable: "",
    abstractStatus: "",
    subjectToSLR: "",
    teamMemberId: ""
}

const allSelectedDataSlice = createSlice({
    name: "allSelectedDataSlice",
    initialState,
    reducers: {
        allSelectedData(state, action: PayloadAction<initialState>) {
            return {
                ...state,
                ...action.payload
            }
        },
        resetState : (state) => {
            return initialState
          
        }
    },
});

export const { allSelectedData , resetState: resetAllSelectedData } = allSelectedDataSlice.actions;

export default allSelectedDataSlice.reducer;
